// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1728px) {
    .scl--jcbs-sub-app-bo-con-st{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-left);
    }
}

@media (max-width: 1440px) {
    .scl--jsabcs-bo-st{
        width: 300px;
    }

    .scl--jbs-car-ti-bo-dis-st{
        width: 100%;
    }

    .scl--jsbcs-bo-inp-co-st{
        width: calc(100% - 300px);
    }
}

@media (max-width: 1280px) {
    .scl--jcbs-sub-app-bo-con-st{
        flex-direction: column;
    }

    .scl--jsabcs-bo-st{
        width: 100%;
    }

    .scl--jbs-car-ti-bo-dis-st{
        height: auto;
        min-height: 300px;
    }

    .scl--jsbcs-bo-inp-co-st{
        width: 100%;
    }

    .scl--jnbs-coun-se-bo-st{
        width: 200px;
    }

    .scl--jnbs-pho-num-bo-st{
        width: calc(100% - 200px);
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobSubmittedSl.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["@media (max-width: 1728px) {\n    .scl--jcbs-sub-app-bo-con-st{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-left);\n    }\n}\n\n@media (max-width: 1440px) {\n    .scl--jsabcs-bo-st{\n        width: 300px;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st{\n        width: 100%;\n    }\n\n    .scl--jsbcs-bo-inp-co-st{\n        width: calc(100% - 300px);\n    }\n}\n\n@media (max-width: 1280px) {\n    .scl--jcbs-sub-app-bo-con-st{\n        flex-direction: column;\n    }\n\n    .scl--jsabcs-bo-st{\n        width: 100%;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st{\n        height: auto;\n        min-height: 300px;\n    }\n\n    .scl--jsbcs-bo-inp-co-st{\n        width: 100%;\n    }\n\n    .scl--jnbs-coun-se-bo-st{\n        width: 200px;\n    }\n\n    .scl--jnbs-pho-num-bo-st{\n        width: calc(100% - 200px);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
